<div class="alert alert-danger text-center mt-25" [hidden]="!error">{{ I18n.InfoMessages.OopsSomethingWentWrong | translate }}</div>
